<script>
import { Overlay } from '../../'
export default {
    name: 'DonchianWidth', mixins: [Overlay],
    methods: {
        meta_info() { return { author: 'TradingCandle', version: '1.0.0', desc: 'Donchian Channel Width Percent',
            preset: { name: 'DonchianWidth $length', side: 'offchart',
                settings: { color: '#2962ff', colors: ['#2962ff', '#ef5350'], lineWidth: 1.5, skipNaN: true } } } },
        use_for() { return ['DonchianWidth'] },
        calc() { return {
            props: { length: { def: 20, text: 'Length', min: 1, step: 1 } },
            conf: { renderer: 'Spline' },
            update: `let upper = highest(high, length)[0], lower = lowest(low, length)[0]
                    let middle = (upper + lower) / 2
                    return middle ? 100 * (upper - lower) / middle : 0`
        } },
    },
}
</script>
